<div class="panel" [ngClass]="style" [class.interactive]="interactive">
    <label>{{label}}
        @if(icon) {<i class="{{icon}}"></i>}
    </label>
    <label>{{value}}</label>

</div>